import api from '../services/api'

const messagesCheck = async (messages) => {
  let isOk = true
  const data = {}
  Object.entries(messages).forEach(
    (e) => (data[e[0]] = e[1].filter((e) => e.by === 'consumer')?.length)
  )
  if (Object.keys(data).length > 0) {
    try {
      const response = await api.post(`/messages-check`, { data })
      if (response.status === 200) {
        isOk = response?.data?.data?.isOk
      } else {
        throw response.data
      }
    } catch (error) {
      isOk = false
      const message = error?.response?.data?.message?.[0]?.value ?? 'error'
      console.error(`[Conversations check routine error]: ${message}`)
    }
  }
  return isOk
}

export default messagesCheck
